<script setup lang="ts">
interface Props {
  message: string
}

defineProps<Props>()
</script>

<template>
  <p class="error-message">{{ message }}</p>
</template>

<style lang="scss" scoped>
.error-message {
  font-size: 12px;
  line-height: 12px;
  margin: 4px 0 0;
  word-break: break-word;
  word-wrap: break-word;
  hyphens: auto;
  transition-duration: 150ms;
  color: #b00020;
}
</style>
